module.exports = __webpack_public_path__ + "static/media/1_avatar.40e337f6.png";